import React, { FunctionComponent } from "react";
import { Table, Tooltip, Grid, Fab, MuiThemeProvider } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import EditIcon from "@material-ui/icons/Edit";
import { useConfigStyles } from "../../configStyles";
import { storeConfigType } from "../storeConfigType";
import { useTableStyles } from "../../../useTableStyle";
import { getDecryptedData } from "../../../../utils/crypto";
import { ThemeProvider } from "@mui/material/styles";

const emptyOptions = {
  pagination: false,
  selectableRows: undefined,
  selectableRowsHeader: false,
  print: false,
  search: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

const columns = ["Name", "Config Value", ""];

const options = {
  selectableRows: undefined,
  selectableRowsHeader: false,
  rowsPerPage: 10,
  rowsPerPageOptions: [5, 10, 15, 25, 50, 100],
  print: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

interface StoreConfigTableProps {
  storeConfigurations: Array<storeConfigType> | any;
  goToEdit: (id: number) => void;
  editStoreConfigPermission: boolean;
}
export const StoreConfigurationTableList: FunctionComponent<StoreConfigTableProps> = ({
  storeConfigurations,
  goToEdit,
  editStoreConfigPermission,
}) => {
  const classes = useConfigStyles();
  const getMuiTheme = useTableStyles();

  if (storeConfigurations && storeConfigurations.length > 0) {
    console.log("storeConfigurations",storeConfigurations);
    return (
      <Table>
        <ThemeProvider theme={getMuiTheme}>
          <MUIDataTable
            title={"Store Configuration List"}
            data={storeConfigurations.map((storeConfig: any) => {
              return [
                storeConfig.name,
                storeConfig.name.slice(-3).toLowerCase() === "pwd"
                  ? getDecryptedData(storeConfig.config_value).replace(
                      /./g,
                      "*"
                    )
                  : storeConfig.config_value,
                <Grid container direction="row" spacing={2}>
                  <Grid
                    item
                    style={{ display: editStoreConfigPermission ? "" : "none" }}
                  >
                    <Tooltip title={"Edit"}>
                      <Fab
                        size="small"
                        aria-label="edit"
                        color="primary"
                        className={classes.editIconMargin}
                        onClick={() => goToEdit(storeConfig.id)}
                      >
                        <EditIcon className={classes.editIcon} />
                      </Fab>
                    </Tooltip>
                  </Grid>
                </Grid>,
              ];
            })}
            columns={columns}
            options={options}
          />
        </ThemeProvider>
      </Table>
    );
  } else {
    return (
      <div className={classes.root}>
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Store Configuration List"}
              columns={columns}
              data={[]}
              options={emptyOptions}
            />
          </ThemeProvider>
        </Table>
      </div>
    );
  }
};
